import React, { useState } from 'react';
import './header.sass';
import './burger.scss';
import { header_lsBurger } from '../const';
// import $ from 'jquery';


export const HeaderSmart = () => {
       
const [burgerClick, setBurgerClick] = useState(false);

const setMenu = () => {
    setBurgerClick(!burgerClick)
}
 
return(
    <>
    <span id="burger-menu" className={burgerClick ? 'burgerActive' : 'burgerFalse'}>
        
                {header_lsBurger.map((item: { textHref : string, href : string }, index: number) => { 
                    return (
                        <div className="headeSmartOpen">
                        <a key={index} href={item.href} className="burgerMenuText" onClick={setMenu}>
                            {item.textHref}
                        </a>
                        </div>
                    )})}
                    
                <div className="headeSmartOpen burgerMenuText" onClick={setMenu}>Закрыть</div>

                <div id="burger-menu-line"></div> 

    </span>

    <div className='burgerWrapper' onClick={setMenu} >
        <div className={"Burger " + (burgerClick ? 'BurgerOpen' : 'BurgerClose')}/>
    </div>
    </>
)}